import { TitleCasePipe } from '@angular/common';
import { Component, Inject, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material/dialog';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Grade } from 'src/app/model/school.model';
import { Student } from 'src/app/model/student/student.model';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { SimpleDatePipe } from 'src/app/pipes/simple-date.pipe';
import Swal from 'sweetalert2';
import { EnrollmentReportStudent } from '../../child-reports/enrollment-report/model/enrollment-report-result.model';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { OrganizationService } from '../../common-components/organizations/service/organization.service';
import { SchoolEnrollmentDetailTypes } from '../model/school-enrollment-detail-types.model';
import { SchoolEnrollmentDetails } from '../model/school-enrollment-details.model';
import { StudentEligibilitiesService } from '../service/student-eligibilities.service';
import { StudentSchoolEnrollmentService } from '../service/student-school-enrollment.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ResolvePromoteEnrollmentDetailsModalComponent } from './resolve-promote-enrollment-details-modal/resolve-promote-enrollment-details-modal.component';

@Component({
    selector: 'promote-student-school-enrollment-modal',
    templateUrl: './promote-student-school-enrollment-modal.component.html',
    styleUrls: ['./promote-student-school-enrollment-modal.component.scss']
})
export class PromoteStudentSchoolEnrollmentModalComponent implements OnInit {
    @Input() students!: EnrollmentReportStudent[];
    schoolEnrollmentDetailsNormalized: any[] = [];

    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();

    @ViewChild('enrollmentForm') childInfoForm: FormGroupDirective;
    form: UntypedFormGroup;

    // Reference Data
    schoolEnrollmentDetailTypes: SchoolEnrollmentDetailTypes[];
    missingEoEStudents: Student[];

    selectedSchoolYear: string = ''; // to hold actual school year value
    selectSchoolYear: string = ''; // for initial edit
    requiresEnrollmentTypes: any = {};
    requiresEnrollmentTypesKeys: string[] = [];
    mixedEnrollmentTypes: boolean = false;

    // Table results
    tableDataSources: MatTableDataSource<any>[] = [];
    duplicateDataSources: MatTableDataSource<any>[] = [];
    ineligibleDataSources: MatTableDataSource<any>[] = [];

    schools: any[];
    newSchoolEnrollment: any[];
    promotingStudents: any[];
    ineligibleStudents: any[];
    duplicateStudents: any[];

    uniqueStudents: any[];

    lowestEligibleStudent: EnrollmentReportStudent;
    highestEnrollmentDateStudent: EnrollmentReportStudent;
    highestWithdrawalDateStudent: EnrollmentReportStudent;
    missingEnrollmentDates = false;
    missingWithdrawalDates = false;
    dateCount: any = {};

    removeIneligibleChildren: boolean = true;
    removeHighGradeError: boolean = true;
    removeInvalidGrades: boolean = true;

    grades: Grade[] = [];
    gradesMapping: any = {};
    disabledGrades: string[] = [];
    gradeOptions = [
        { INDEX: 1, GRADES: 'P0', selectable: true },
        { INDEX: 2, GRADES: 'P1', selectable: true },
        { INDEX: 3, GRADES: 'P2', selectable: true },
        { INDEX: 4, GRADES: 'P3', selectable: true },
        { INDEX: 5, GRADES: 'P4', selectable: true },
        { INDEX: 6, GRADES: 'P5', selectable: true },
        { INDEX: 7, GRADES: 'P6', selectable: true },
        { INDEX: 8, GRADES: 'PK', selectable: true, requires: ['R'] },
        { INDEX: 9, GRADES: 'TK', selectable: true, requires: ['R'] },
        { INDEX: 10, GRADES: 'K', selectable: true, requires: ['R'] },
        { INDEX: 11, GRADES: '01', selectable: true, requires: ['R'] },
        { INDEX: 12, GRADES: '02', selectable: true, requires: ['R'] },
        { INDEX: 13, GRADES: '03', selectable: true, requires: ['R'] },
        { INDEX: 14, GRADES: '04', selectable: true, requires: ['R'] },
        { INDEX: 15, GRADES: '05', selectable: true, requires: ['R'] },
        { INDEX: 16, GRADES: '06', selectable: true, requires: ['R'] },
        { INDEX: 17, GRADES: '07', selectable: true, requires: ['R'] },
        { INDEX: 18, GRADES: '08', selectable: true, requires: ['R'] },
        { INDEX: 19, GRADES: '09', selectable: true, requires: ['R'] },
        { INDEX: 20, GRADES: '10', selectable: true, requires: ['R'] },
        { INDEX: 21, GRADES: '11', selectable: true, requires: ['R'] },
        { INDEX: 22, GRADES: '12', selectable: true, requires: ['R'] },
        { INDEX: 23, GRADES: 'UG', selectable: true, requires: ['R'], static: true },
        { INDEX: 24, GRADES: 'AD', selectable: true, requires: ['R'] },
        { INDEX: 25, GRADES: 'NA', selectable: true, requires: ['N'], static: true }
    ];

    // School Enrollment Data
    schoolEnrollmentDetails: SchoolEnrollmentDetails[] = [];
    sed: any = {};

    // Date options
    maxEndOfEligibilityStudent: Student;
    maxTerminationStudent: Student;
    dateFlags: any[] = [];
    creationFlags: any[] = [];

    // Table display
    displayedColumns = ['EDIT', 'MSD_NUMBER', 'NAME'];
    duplicateDisplayedColumns = ['SIZE', 'PERSON.LAST_NAME', 'MSD_NUMBER'];
    ineligibleDisplayedColumns = ['PERSON.LAST_NAME', 'MSD_NUMBER', 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'];

    // Component letiables
    resetField: boolean = false;

    isLoading: boolean = false;
    isSaving: boolean = false;
    isSubmitting: boolean = false;

    promises: Array<any> = [];

    msg: MsgModel;

    // Help Text
    lstQuestionHelpText: QuestionHelpText[] = [];

    // Pipes
    cleanDatePipe: CleanDatePipe = new CleanDatePipe();
    simpleDatePipe: SimpleDatePipe = new SimpleDatePipe();
    getPropertyPipe: GetPropertyPipe = new GetPropertyPipe();
    titlecasePipe: TitleCasePipe = new TitleCasePipe();

    constructor(
        public dialogRef: MatDialogRef<PromoteStudentSchoolEnrollmentModalComponent>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private studentSchoolEnrollmentService: StudentSchoolEnrollmentService,
        private studentEligibilitiesService: StudentEligibilitiesService,
        private organizationService: OrganizationService
    ) {}

    ngOnInit(): void {
        this.isLoading = true;

        // Use data IDs if exists
        if (this.data) {
            this.students = this.data.students;
        }

        // Reference API calls
        this.getSchoolEnrollmentDetailTypes();
        this.getGrades();

        // Needed
        this.getLatestCoeAndEligiblity(this.students);

        Promise.all(this.promises).then((res) => {
            this.buildStudentsIntoSchoolEnrollments();
            this.updateDataSource();
            this.updateDuplicateDataSource();
            this.updateIneligibleDataSource();

            this.isLoading = false;
        });
    }

    /*
     * API functions
     */
    getSchoolEnrollmentDetailTypes() {
        let deferred = new Promise((resolve, reject) => {
            this.studentSchoolEnrollmentService.getSchoolEnrollmentDetailTypes().subscribe((res) => {
                if (res.schoolEnrollmentDetailTypes) {
                    this.schoolEnrollmentDetailTypes = res.schoolEnrollmentDetailTypes;
                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }
    getLatestCoeAndEligiblity(students: Student[]) {
        let deferred = new Promise((resolve, reject) => {
            this.studentEligibilitiesService.getLatestCoeAndEligiblity(students).subscribe((res) => {
                if (res.students) {
                    this.missingEoEStudents = res.students;

                    this.setEligibilityAndTerminationRestrictions(this.missingEoEStudents);

                    resolve(res);
                } else if (res?.msg) {
                    resolve(res);
                } else {
                    reject('err');
                }
            });
        });

        this.promises.push(deferred);
    }
    getGrades() {
        let deferred = new Promise((resolve, reject) => {
            this.organizationService.getGradesTable().subscribe((res) => {
                if (res.grades) {
                    this.grades = this.combineGrades(res.grades);
                }

                if (res.gradesMapping) {
                    this.gradesMapping = {};

                    res.gradesMapping.forEach((gm: any) => {
                        this.gradesMapping[gm.GRADES_FROM.GRADES] = gm.GRADES_FROM;
                        this.gradesMapping[gm.GRADES_FROM.GRADES]['NEXT'] = gm.GRADES_NEXT;
                    });
                }

                resolve(res);
            });
        });

        this.promises.push(deferred);
    }

    combineGrades(grades: Grade[]): Grade[] {
        let output: any[] = [];

        this.gradeOptions.forEach((obj: any) => {
            let findGrade = grades.find((grade: Grade) => grade.GRADES === obj.GRADES);

            output.push({ ...obj, ...findGrade });
        });

        if (this.disabledGrades) {
            this.disabledGrades.forEach((dg) => {
                let findGradeIndex = grades.findIndex((grade: Grade) => grade.GRADES === dg);

                if (findGradeIndex >= 0) {
                    output[findGradeIndex].ACTIVE = false;
                }
            });
        }

        return output;
    }

    setEligibilityAndTerminationRestrictions(students: Student[]) {
        students.forEach((student) => {
            let eoeDate = this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            );

            if (eoeDate) {
                if (!this.maxEndOfEligibilityStudent) {
                    this.maxEndOfEligibilityStudent = student;
                } else {
                    let currentEoE = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(
                            this.maxEndOfEligibilityStudent,
                            'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                        )
                    );

                    if (new Date(eoeDate) < new Date(currentEoE)) {
                        this.maxEndOfEligibilityStudent = student;
                    }
                }
            }

            let terminationID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].ID');
            let terminationDate = this.cleanDatePipe.transform(this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE'));
            let terminationTypeID = this.getPropertyPipe.transform(student, 'STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.ID');

            if (terminationID) {
                if (!this.maxTerminationStudent && terminationTypeID !== 1) {
                    this.maxTerminationStudent = student;
                } else {
                    let currentTerminationDate = this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(this.maxTerminationStudent, 'STUDENT_TERMINATION_STATUSES[0].STATUS_DATE')
                    );

                    if (new Date(terminationDate) < new Date(currentTerminationDate) && terminationTypeID !== 1) {
                        this.maxTerminationStudent = student;
                    }
                }
            }
        });
    }

    buildStudentsIntoSchoolEnrollments() {
        this.schools = [];
        this.newSchoolEnrollment = [];
        this.promotingStudents = [];
        this.ineligibleStudents = [];

        this.uniqueStudents = this.resolveDuplicateStudents(this.students);

        this.uniqueStudents.forEach((student: any) => {
            let found = false;
            this.schools.forEach((school: any, schoolIndex: number) => {
                school.SCHOOL_ENROLLMENTS.forEach((schoolEnrollment: any, seIndex: number) => {
                    if (this.matchStudentSchool(student, school, schoolEnrollment)) {
                        this.pushStudent(student, school, schoolIndex, schoolEnrollment, seIndex);
                        found = true;
                    }
                });

                if (!found && school.ID === student.SCHOOL.ID) {
                    this.pushSchoolEnrollment(student, school);
                    found = true;
                }
            });

            if (!found) {
                this.newSchoolAndGrade(student);
            }
        });

        // Sort by Grade
        this.schools.forEach((school: any, schoolIndex: number) => {
            school.SCHOOL_ENROLLMENTS = school.SCHOOL_ENROLLMENTS.sort((n1: any, n2: any) =>
                n1.schoolEnrollmentDetails.Grade! > n2.schoolEnrollmentDetails.Grade! ? 1 : -1
            );
        });
    }

    resolveDuplicateStudents(students: any[]) {
        let uniques = [...new Map(students.map((s) => [s['ID'], s])).values()];
        this.duplicateStudents = this.getDuplicateStudents();

        return uniques;
    }

    getDuplicateStudents() {
        let groupedBy = this.groupBy(this.students, 'ID');
        let duplicateStudents = [];

        for (let propertyName in groupedBy) {
            if (groupedBy[propertyName].length > 1) {
                groupedBy[propertyName][0].SIZE = groupedBy[propertyName].length;
                duplicateStudents.push(groupedBy[propertyName][0]);
            }
        }

        return duplicateStudents;
    }

    groupBy(xs: any[], key: string) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    matchStudentSchool(student: any, school: any, schoolEnrollment: any) {
        if (
            school.ID == student.SCHOOL.ID &&
            schoolEnrollment.currentGrade.replace(/ /g, '') == student.SCHOOL_ENROLLMENT_DETAILS[0].GRADE.replace(/ /g, '') &&
            schoolEnrollment.schoolEnrollmentDetails.EnrollmentType.replace(/ /g, '') ==
                student.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE.replace(/ /g, '') &&
            (schoolEnrollment.schoolEnrollmentDetails.Track
                ? schoolEnrollment.schoolEnrollmentDetails.Track.replace(/ /g, '') == student.SCHOOL_ENROLLMENT_DETAILS[0].TRACK.replace(/ /g, '')
                : true) &&
            schoolEnrollment.currentSchoolYear == this.normalizeSchoolYear(student.SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR)
        ) {
            return true;
        } else {
            return false;
        }
    }

    newSchoolAndGrade(student: any) {
        if (this.removeIneligibleChildren) {
            if (this.hasIneligibility(student)) {
                this.ineligibleStudents.push(student);
                return;
            }
        }
        if (this.removeHighGradeError) {
            if (this.hasHighGradeError(student)) {
                return;
            }
        }
        if (this.removeInvalidGrades) {
            if (this.hasInvalidGrades(student)) {
                return;
            }
        }

        let newSchool = JSON.parse(JSON.stringify(student.SCHOOL));
        newSchool.REGION = student.REGION;
        newSchool.COUNTy = student.COUNTy;
        newSchool.SCHOOL_DISTRICTS = student.SCHOOL_DISTRICTS;
        newSchool.SCHOOL_ENROLLMENTS = [];

        this.pushSchoolEnrollment(student, newSchool);

        this.schools.push(newSchool);
    }

    pushStudent(student: any, school: any, schoolIndex: any, schoolEnrollment: any, seIndex: any) {
        if (this.removeIneligibleChildren) {
            if (this.hasIneligibility(student)) {
                this.ineligibleStudents.push(student);
                return;
            }
        }
        if (this.removeHighGradeError) {
            if (this.hasHighGradeError(student)) {
                return;
            }
        }
        if (this.removeInvalidGrades) {
            if (this.hasInvalidGrades(student)) {
                return;
            }
        }

        school.SCHOOL_ENROLLMENTS[seIndex].STUDENTS.push(this.minifyStudent(student));
        this.promotingStudents.push(this.minifyStudent(student));

        this.setLowestEligibleStudent(student, schoolEnrollment);
        this.resolveLowestEligibleStudent(schoolEnrollment);
    }

    pushSchoolEnrollment(student: any, school: any) {
        if (this.removeIneligibleChildren) {
            if (this.hasIneligibility(student)) {
                this.ineligibleStudents.push(student);
                return;
            }
        }
        if (this.removeHighGradeError) {
            if (this.hasHighGradeError(student)) {
                return;
            }
        }
        if (this.removeInvalidGrades) {
            if (this.hasInvalidGrades(student)) {
                return;
            }
        }

        let newSchoolEnrollment: any = { schoolEnrollmentDetails: {}, STUDENTS: [] };

        newSchoolEnrollment.STUDENTS.push(this.minifyStudent(student));
        this.promotingStudents.push(this.minifyStudent(student));

        newSchoolEnrollment.schoolEnrollmentDetails.EnrollmentType = student.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE;
        newSchoolEnrollment.schoolEnrollmentDetails.Track = student.SCHOOL_ENROLLMENT_DETAILS[0].TRACK;

        this.setNextGrade(school, newSchoolEnrollment, student.SCHOOL_ENROLLMENT_DETAILS[0].GRADE);
        this.setNextSchoolYear(newSchoolEnrollment, student.SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR);

        let currentYear: number;

        if (new Date().getMonth() >= 6) {
            currentYear = parseInt(newSchoolEnrollment.schoolEnrollmentDetails.SchoolYear.substring(0, 4));
        } else {
            currentYear = parseInt(
                newSchoolEnrollment.schoolEnrollmentDetails.SchoolYear.substring(0, 2) + newSchoolEnrollment.schoolEnrollmentDetails.SchoolYear.substring(5, 7)
            );
        }

        if (newSchoolEnrollment.schoolEnrollmentDetails.EnrollmentType === 'R') {
            newSchoolEnrollment.schoolEnrollmentDetails.EnrollmentDate = new Date(currentYear, new Date().getMonth(), new Date().getDate());
        }

        school.SCHOOL_ENROLLMENTS.push(newSchoolEnrollment);

        this.setLowestEligibleStudent(student, school.SCHOOL_ENROLLMENTS[school.SCHOOL_ENROLLMENTS.length - 1]);
        this.resolveLowestEligibleStudent(school.SCHOOL_ENROLLMENTS[school.SCHOOL_ENROLLMENTS.length - 1]);
    }

    hasIneligibility(student: any) {
        let schoolYear = this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR');
        let nextYear = this.getNextSchoolYear(schoolYear);

        if (
            this.cleanDatePipe.transform(
                this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
            ) < new Date('07/01/' + nextYear)
        ) {
            return true;
        }
        return false;
    }

    hasHighGradeError(student: any) {
        if (student.SCHOOL.HIGH_GRADE > 0) {
            let grade = this.grades.find((g) => {
                return g.GRADES == this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE');
            });

            if (grade && grade.ID == student.SCHOOL.HIGH_GRADE) {
                return true;
            }
        }

        return false;
    }

    hasInvalidGrades(student: any) {
        let grade = this.grades.find((g) => {
            return g.GRADES == this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].GRADE');
        });

        if (!grade || (grade && !grade.ID)) {
            return true;
        }

        return false;
    }

    minifyStudent(student: any) {
        return { ID: student.ID, MSD_NUMBER: student.MSD_NUMBER, NAME: this.getStudentName(student), ENABLED: true };
    }

    getStudentName(student: Student) {
        let name: string = '';
        name += student.PERSON.LAST_NAME;
        name += student.SECOND_LAST_NAME ? ' ' + student.SECOND_LAST_NAME : '';
        name += ', ' + student.PERSON.FIRST_NAME;
        name += student.PERSON.MIDDLE_INITIAL ? ' ' + student.PERSON.MIDDLE_INITIAL : '';

        name = this.titlecasePipe.transform(name);
        return name;
    }

    normalizeSchoolYear(schoolYear: string) {
        if (schoolYear.length == 4) {
            return '20' + schoolYear.substring(0, 2) + '-' + schoolYear.substring(2, 4);
        } else if (schoolYear.length == 7) {
            return schoolYear.substring(0, 4) + '-' + schoolYear.substring(5, 7);
        } else {
            return null;
        }
    }

    setLowestEligibleStudent(student: any, schoolEnrollment: any) {
        let eoeDate = this.cleanDatePipe.transform(
            this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
        );

        if (eoeDate) {
            if (!schoolEnrollment.lowestEligibleStudent) {
                schoolEnrollment.lowestEligibleStudent = student;
            } else {
                let currentEoE = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(
                        schoolEnrollment.lowestEligibleStudent,
                        'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                    )
                );

                if (new Date(eoeDate) < new Date(currentEoE)) {
                    schoolEnrollment.lowestEligibleStudent = student;
                }
            }
        }
    }

    setAndFindLowestEligibleStudent(schoolEnrollment: any) {
        schoolEnrollment.lowestEligibleStudent = undefined;

        schoolEnrollment.STUDENTS.forEach((s: any) => {
            if (s.ENABLED) {
                let student = this.uniqueStudents.find((us) => us.ID === s.ID);

                let eoeDate = this.cleanDatePipe.transform(
                    this.getPropertyPipe.transform(student, 'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE')
                );

                if (eoeDate) {
                    if (!schoolEnrollment.lowestEligibleStudent) {
                        schoolEnrollment.lowestEligibleStudent = student;
                    } else {
                        let currentEoE = this.cleanDatePipe.transform(
                            this.getPropertyPipe.transform(
                                schoolEnrollment.lowestEligibleStudent,
                                'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                            )
                        );

                        if (new Date(eoeDate) < new Date(currentEoE)) {
                            schoolEnrollment.lowestEligibleStudent = student;
                        }
                    }
                }
            }
        });
    }

    resolveLowestEligibleStudent(schoolEnrollment: any) {
        if (this.getPropertyPipe.transform(schoolEnrollment, 'schoolEnrollmentDetails.SchoolYear')) {
            let minYear = schoolEnrollment.schoolEnrollmentDetails.SchoolYear.substring(0, 4);
            let maxYear =
                schoolEnrollment.schoolEnrollmentDetails.SchoolYear.substring(0, 2) + schoolEnrollment.schoolEnrollmentDetails.SchoolYear.substring(5, 7);

            schoolEnrollment.enrollmentDateOptions = {
                datepickerMode: 'year',
                minDate: new Date('07/01/"' + minYear + '"'),
                maxDate: new Date('06/30/"' + maxYear + '"')
            };

            if (schoolEnrollment.lowestEligibleStudent) {
                if (
                    this.cleanDatePipe.transform(
                        this.getPropertyPipe.transform(
                            schoolEnrollment.lowestEligibleStudent,
                            'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                        )
                    ) >= new Date('06/30/"' + maxYear + '"')
                ) {
                    schoolEnrollment.hasEnrollmentDateRestriction = false;
                    schoolEnrollment.enrollmentDateOptions.maxDate = new Date('06/30/"' + maxYear + '"');
                } else {
                    schoolEnrollment.hasEnrollmentDateRestriction = true;
                    schoolEnrollment.enrollmentDateOptions.maxDate = new Date(
                        this.cleanDatePipe.transform(
                            this.getPropertyPipe.transform(
                                schoolEnrollment.lowestEligibleStudent,
                                'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                            )
                        )
                    );
                    if (schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate >= schoolEnrollment.enrollmentDateOptions.maxDate) {
                        schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate = schoolEnrollment.enrollmentDateOptions.maxDate;
                    }
                }

                if (
                    new Date(
                        this.cleanDatePipe.transform(
                            this.getPropertyPipe.transform(
                                schoolEnrollment.lowestEligibleStudent,
                                'SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE'
                            )
                        )
                    ) < schoolEnrollment.enrollmentDateOptions.minDate
                ) {
                    schoolEnrollment.endOfEligibilityError = true;
                    schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate = '';
                } else {
                    schoolEnrollment.endOfEligibilityError = false;
                }
            } else {
                schoolEnrollment.hasEnrollmentDateRestriction = false;
                schoolEnrollment.enrollmentDateOptions.maxDate = new Date('06/30/"' + maxYear + '"');
            }

            if (
                schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate < schoolEnrollment.enrollmentDateOptions.minDate &&
                !schoolEnrollment.endOfEligibilityError
            ) {
                schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate = schoolEnrollment.enrollmentDateOptions.minDate;
            }

            // Remove Enrollment Date for N type
            if (schoolEnrollment.schoolEnrollmentDetails.EnrollmentType === 'N') {
                schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate = '';
            }
        }
    }

    setNextGrade(school: any, schoolEnrollment: any, currentGrade: any) {
        schoolEnrollment.currentGrade = currentGrade.replace(/ /g, '');

        let grade: any = this.grades.find((g: any) => {
            return g.GRADES == schoolEnrollment.currentGrade;
        });

        if (grade && grade.static) {
            schoolEnrollment.schoolEnrollmentDetails.Grade = grade.GRADES;
        } else if (this.gradesMapping && this.gradesMapping[schoolEnrollment.currentGrade] && this.gradesMapping[schoolEnrollment.currentGrade].ID) {
            if (school.HIGH_GRADE > 0) {
                if (grade.ID === school.HIGH_GRADE) {
                    schoolEnrollment.HIGH_GRADE_ERROR = true;
                } else if (
                    this.gradesMapping &&
                    this.gradesMapping[schoolEnrollment.currentGrade] &&
                    this.gradesMapping[schoolEnrollment.currentGrade].NEXT.GRADES
                ) {
                    schoolEnrollment.schoolEnrollmentDetails.Grade = this.gradesMapping[schoolEnrollment.currentGrade].NEXT.GRADES;
                } else {
                    schoolEnrollment.HIGH_GRADE_ERROR = true;
                }
            } else {
                schoolEnrollment.schoolEnrollmentDetails.Grade = this.gradesMapping[schoolEnrollment.currentGrade].NEXT.GRADES;
            }
        } else {
            schoolEnrollment.INVALID_GRADE = true;
        }
    }

    setNextSchoolYear(schoolEnrollment: any, schoolYear: any) {
        let currentSchoolYear = this.normalizeSchoolYear(schoolYear);
        if (currentSchoolYear) {
            schoolEnrollment.currentSchoolYear = currentSchoolYear;
            schoolEnrollment.schoolEnrollmentDetails.SchoolYear =
                +currentSchoolYear.substring(0, 4) + 1 + '-' + (+currentSchoolYear.substring(5, 7) + 1 >= 100 ? '00' : +currentSchoolYear.substring(5, 7) + 1);
        } else {
            schoolEnrollment.INVALID_SCHOOL_YEAR = true;
        }
    }

    getNextSchoolYear(schoolYear: any) {
        let currentSchoolYear = this.normalizeSchoolYear(schoolYear);
        if (currentSchoolYear) {
            return +currentSchoolYear.substring(0, 4) + 1;
        } else {
            return '1900-01';
        }
    }

    /****************************************************************************************
 		Add Functions
	****************************************************************************************/
    promote() {
        this.isSubmitting = true;
        if (this.checkValid()) {
            this.isLoading = true;

            this.fillSchoolEnrollmentDetails().then(() => {
                this.studentSchoolEnrollmentService.promote(this.resolveOnlyChosenStudents(this.schools)).subscribe({
                    next: (res) => {
                        if (res.msg) {
                            if (res.msg.SUCCESS) {
                                this.msg = res.msg;

                                this.msg.MSG += ' (closing modal in 3 seconds...)';
                                setTimeout(() => {
                                    this.dialogRef.close({ refresh: true });
                                }, 3000);
                            } else {
                                this.msg = res.msg;
                            }
                        } else {
                            this.msg = { MSG: 'There was an error promoting these child enrollments.', SUCCESS: false };
                        }
                    },
                    error: (err) => {
                        if (err.msg) {
                            this.msg = err.msg;
                        } else {
                            this.msg = { MSG: 'Server error.', SUCCESS: false };
                        }
                    },
                    complete: () => {
                        this.isSubmitting = false;
                    }
                });
            });
        } else {
            this.msg = { MSG: 'Please check your inputs.', SUCCESS: false };
            this.isSubmitting = false;
        }
    }

    checkValid(schoolEnrollment?: any) {
        let valid = true;

        if (schoolEnrollment) {
            if (this.hasAtLeastOneStudent(schoolEnrollment)) {
                if (
                    schoolEnrollment.HIGH_GRADE_ERROR ||
                    schoolEnrollment.INVALID_GRADE ||
                    schoolEnrollment.INVALID_SCHOOL_YEAR ||
                    schoolEnrollment.endOfEligibilityError ||
                    (schoolEnrollment.schoolEnrollmentDetails.EnrollmentType === 'R' && !schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate)
                ) {
                    return (valid = false);
                }
            }
        } else {
            this.schools.forEach((school) => {
                school.SCHOOL_ENROLLMENTS.forEach((schoolEnrollment: any) => {
                    if (this.hasAtLeastOneStudent(schoolEnrollment)) {
                        if (
                            schoolEnrollment.HIGH_GRADE_ERROR ||
                            schoolEnrollment.INVALID_GRADE ||
                            schoolEnrollment.INVALID_SCHOOL_YEAR ||
                            schoolEnrollment.endOfEligibilityError ||
                            (schoolEnrollment.schoolEnrollmentDetails.EnrollmentType === 'R' && !schoolEnrollment.schoolEnrollmentDetails.EnrollmentDate)
                        ) {
                            return (valid = false);
                        }
                    }

                    if (!valid) {
                        return (valid = false);
                    } else {
                        return (valid = true);
                    }
                });
            });
        }

        return valid;
    }

    resolveOnlyChosenStudents(school: any) {
        let returnSchool = JSON.parse(JSON.stringify(school));

        returnSchool.forEach((school: any) => {
            school.SCHOOL_ENROLLMENTS.forEach((schoolEnrollment: any) => {
                schoolEnrollment.STUDENTS = schoolEnrollment.STUDENTS.filter((student: any) => {
                    return student.ENABLED;
                });
            });
        });

        return returnSchool;
    }
    /****************************************************************************************
		Get Functions
	****************************************************************************************/
    fillSchoolEnrollmentDetails() {
        let promises: any[] = [];

        this.schools.forEach((school: any) => {
            school.SCHOOL_ENROLLMENTS.forEach((schoolEnrollment: any) => {
                let deferred = new Promise((resolve, reject) => {
                    schoolEnrollment.SCHOOL_ENROLLMENT_DETAILS = [];

                    for (let propertyName in schoolEnrollment.schoolEnrollmentDetails) {
                        if (
                            schoolEnrollment.schoolEnrollmentDetails.hasOwnProperty(propertyName) &&
                            propertyName.indexOf('_SCHOOL_ENROLLMENTS_ID') === -1 &&
                            propertyName.indexOf('_SCHOOL_ENROLLMENT_DETAIL_TYPES_ID') === -1
                        ) {
                            if (schoolEnrollment.schoolEnrollmentDetails && schoolEnrollment.schoolEnrollmentDetails[propertyName]) {
                                schoolEnrollment.SCHOOL_ENROLLMENT_DETAILS.push({
                                    SCHOOL_ENROLLMENT_DETAIL_TYPES_ID: schoolEnrollment.schoolEnrollmentDetails[
                                        propertyName + '_SCHOOL_ENROLLMENT_DETAIL_TYPES_ID'
                                    ]
                                        ? schoolEnrollment.schoolEnrollmentDetails[propertyName + '_SCHOOL_ENROLLMENT_DETAIL_TYPES_ID']
                                        : this.getEnrollmentDetailTypesId(propertyName),
                                    VALUE: schoolEnrollment.schoolEnrollmentDetails[propertyName]
                                        ? schoolEnrollment.schoolEnrollmentDetails[propertyName].ID
                                            ? schoolEnrollment.schoolEnrollmentDetails[propertyName].ID
                                            : schoolEnrollment.schoolEnrollmentDetails[propertyName]
                                        : ''
                                });
                            }
                        }
                    }

                    resolve(true);
                });

                this.promises.push(deferred);
            });
        });

        return Promise.all(this.promises);
    }

    getEnrollmentDetailTypesId(propertyName: string) {
        let schoolEnrollmentDetailType = this.schoolEnrollmentDetailTypes.find((type: any) => {
            return type.TYPE === propertyName;
        });

        return schoolEnrollmentDetailType ? schoolEnrollmentDetailType.ID : undefined;
    }

    hasAtLeastOneStudent(schoolEnrollment: any) {
        let found = false;

        found = schoolEnrollment.STUDENTS.find((student: any) => {
            if (student.ENABLED) {
                return (found = true);
            } else {
                return (found = false);
            }
        });

        return !!found;
    }

    getEnabledStudentsCount(students: any[]) {
        if (students) {
            return students.filter((student) => {
                return student.ENABLED;
            }).length;
        } else return 0;
    }

    /****************************************************************************************
		Table Functions
	****************************************************************************************/
    updateDataSource(newSort?: boolean) {
        setTimeout(() => {
            let index = 0;
            this.tableDataSources = [];

            this.schools.forEach((school: any) => {
                school.SCHOOL_ENROLLMENTS.forEach((schoolEnrollment: any) => {
                    schoolEnrollment.INDEX = index;
                    // Data
                    let dataSource = new MatTableDataSource<any>();
                    dataSource.data = schoolEnrollment.STUDENTS.sort((n1: any, n2: any) => (n1.NAME! > n2.NAME! ? 1 : -1));

                    // Paginator
                    dataSource.paginator = this.paginators.toArray()[index];

                    // Sort
                    // dataSource.sort = this.sorts.toArray()[index];
                    // dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
                    // if (newSort) {
                    //     const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
                    //     dataSource.sort.active = defaultSort.active;
                    //     dataSource.sort.direction = defaultSort.direction;
                    //     dataSource.sort.sortChange.emit(defaultSort);
                    // } else {
                    //     dataSource.sort.sortChange.emit(this.sorts.toArray()[index]);
                    // }

                    // Filter
                    dataSource.filterPredicate = (data: any, filter) => {
                        const dataStr = JSON.stringify(data).toLowerCase();
                        return dataStr.indexOf(filter) != -1;
                    };

                    this.tableDataSources.push(dataSource);
                    index += 1;
                });
            });
        }, 100);
    }

    updateDuplicateDataSource(newSort?: boolean) {
        setTimeout(() => {
            this.duplicateDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.duplicateStudents.sort((n1: any, n2: any) => (n1.LAST_NAME! > n2.LAST_NAME! ? 1 : -1));

            // Paginator
            //dataSource.paginator = this.paginators.toArray()[index];

            // Sort
            // dataSource.sort = this.sorts.toArray()[index];
            // dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            // if (newSort) {
            //     const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
            //     dataSource.sort.active = defaultSort.active;
            //     dataSource.sort.direction = defaultSort.direction;
            //     dataSource.sort.sortChange.emit(defaultSort);
            // } else {
            //     dataSource.sort.sortChange.emit(this.sorts.toArray()[index]);
            // }

            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.duplicateDataSources.push(dataSource);
        }, 100);
    }

    updateIneligibleDataSource(newSort?: boolean) {
        setTimeout(() => {
            this.ineligibleDataSources = [];

            // Data
            let dataSource = new MatTableDataSource<any>();
            dataSource.data = this.ineligibleStudents.sort((n1: any, n2: any) => (n1.LAST_NAME! > n2.LAST_NAME! ? 1 : -1));

            // Paginator
            //dataSource.paginator = this.paginators.toArray()[index];

            // Sort
            // dataSource.sort = this.sorts.toArray()[index];
            // dataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);
            // if (newSort) {
            //     const defaultSort: Sort = { active: 'NAME', direction: 'asc' };
            //     dataSource.sort.active = defaultSort.active;
            //     dataSource.sort.direction = defaultSort.direction;
            //     dataSource.sort.sortChange.emit(defaultSort);
            // } else {
            //     dataSource.sort.sortChange.emit(this.sorts.toArray()[index]);
            // }

            // Filter
            dataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };

            this.ineligibleDataSources.push(dataSource);
        }, 100);
    }

    toggleRemoveIneligibleChildren() {
        this.buildStudentsIntoSchoolEnrollments();
        this.updateDataSource();
        this.updateDuplicateDataSource();
        this.updateIneligibleDataSource();
    }

    toggleAllStudents(schoolEnrollment: any) {
        if (this.hasAtLeastOneStudent(schoolEnrollment)) {
            schoolEnrollment.STUDENTS.forEach((student: any) => {
                student.ENABLED = false;
                let promotingStudent = this.promotingStudents.find((ps: any) => {
                    return ps.ID === student.ID;
                });
                promotingStudent.ENABLED = false;
            });
        } else {
            schoolEnrollment.STUDENTS.forEach((student: any) => {
                student.ENABLED = true;
                let promotingStudent = this.promotingStudents.find((ps: any) => {
                    return ps.ID === student.ID;
                });
                promotingStudent.ENABLED = true;
            });
        }

        this.setAndFindLowestEligibleStudent(schoolEnrollment);
        this.resolveLowestEligibleStudent(schoolEnrollment);
    }

    toggleStudent(student: any, schoolEnrollment: any) {
        student.ENABLED = !student.ENABLED;
        let promotingStudent = this.promotingStudents.find((ps: any) => {
            return ps.ID === student.ID;
        });
        promotingStudent.ENABLED = !promotingStudent.ENABLED;

        this.setAndFindLowestEligibleStudent(schoolEnrollment);
        this.resolveLowestEligibleStudent(schoolEnrollment);
    }

    // Dialog function
    closeDialog(closed: boolean) {
        Swal.fire({
            titleText: 'Are you sure you want to continue without saving?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Go Back',
            icon: 'warning',
            confirmButtonColor: '#3a6b35'
        }).then((result: any) => {
            if (result.isConfirmed) {
                this.dialogRef.close();
            }
        });
    }

    resolveDialog(schoolEnrollment?: any[], school?: any) {
        let payload: any = {};
        payload.schoolEnrollment = JSON.parse(JSON.stringify(schoolEnrollment));
        payload.location = {
            REGIONS_ID: school.REGION.ID,
            COUNTIES_ID: school.COUNTy.ID,
            SCHOOL_DISTRICTS_ID: school.SCHOOL_DISTRICTS.ID,
            SCHOOLS_ID: school.ID
        };
        payload.uniqueStudents = this.uniqueStudents;

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '80vw';
        const dialogRef = this.dialog.open(ResolvePromoteEnrollmentDetailsModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            this.resolveSchoolEnrollment(schoolEnrollment, school, res.newSchoolEnrollment, res.location);
            this.updateDataSource();
        });
    }

    resolveSchoolEnrollment(currentSchoolEnrollment: any, currentSchool: any, newSchoolEnrollment: any, newLocation: any) {
        this.isLoading = true;

        let targetSchool = this.schools.find((school: any) => {
            return newLocation.SCHOOL.ID === school.ID;
        });

        if (targetSchool && targetSchool.ID === currentSchool.ID) {
            currentSchoolEnrollment.schoolEnrollmentDetails = JSON.parse(JSON.stringify(newSchoolEnrollment.schoolEnrollmentDetails));
            currentSchoolEnrollment.STUDENTS = JSON.parse(JSON.stringify(newSchoolEnrollment.STUDENTS));

            currentSchoolEnrollment.HIGH_GRADE_ERROR = false;
            currentSchoolEnrollment.INVALID_GRADE = false;
            currentSchoolEnrollment.INVALID_SCHOOL_YEAR = false;

            this.setAndFindLowestEligibleStudent(currentSchoolEnrollment);
            this.resolveLowestEligibleStudent(currentSchoolEnrollment);
        } else {
            // Keep non-ENABLED students
            currentSchoolEnrollment.STUDENTS = JSON.parse(JSON.stringify(newSchoolEnrollment.STUDENTS)).filter((s: any) => {
                return !s.ENABLED;
            });
            currentSchoolEnrollment.STUDENTS.forEach((s: any) => {
                s.ENABLED = true;
            });
            if (currentSchoolEnrollment.STUDENTS.length === 0) {
                // Splice school enrollments
                currentSchool.SCHOOL_ENROLLMENTS.splice(currentSchool.SCHOOL_ENROLLMENTS.indexOf(currentSchoolEnrollment), 1);
                // Splice school
                if (currentSchool.SCHOOL_ENROLLMENTS.length === 0) {
                    this.schools.splice(this.schools.indexOf(currentSchool), 1);
                }
            }

            let findSchool = this.schools.find((school: any) => {
                return newLocation.SCHOOL.ID === school.ID;
            });

            if (findSchool) {
                newSchoolEnrollment.STUDENTS = newSchoolEnrollment.STUDENTS.filter((s: any) => {
                    return s.ENABLED;
                });

                this.setAndFindLowestEligibleStudent(newSchoolEnrollment);
                this.resolveLowestEligibleStudent(newSchoolEnrollment);

                findSchool.SCHOOL_ENROLLMENTS.push(newSchoolEnrollment);
            } else {
                let newSchool = JSON.parse(JSON.stringify(newLocation.SCHOOL));
                newSchool.REGION = JSON.parse(JSON.stringify(newLocation.REGION));
                newSchool.COUNTy = JSON.parse(JSON.stringify(newLocation.COUNTy));
                newSchool.SCHOOL_DISTRICTS = JSON.parse(JSON.stringify(newLocation.SCHOOL_DISTRICTS));
                newSchool.SCHOOL_ENROLLMENTS = [];

                newSchoolEnrollment.STUDENTS = newSchoolEnrollment.STUDENTS.filter((s: any) => {
                    return s.ENABLED;
                });
                this.setAndFindLowestEligibleStudent(newSchoolEnrollment);
                this.resolveLowestEligibleStudent(newSchoolEnrollment);

                newSchool.SCHOOL_ENROLLMENTS.push(newSchoolEnrollment);

                this.schools.push(newSchool);
            }
        }

        this.isLoading = false;
        //this.closeResolveSchoolEnrollment();
    }
}
